import React from 'react'

import { Button, Card, CardActions, CardContent, CardHeader } from '@mui/material'

import NameToDomainCsvUpload from 'components/name-to-domain/NameToDomainCSVUpload'
import NameToDomainFields from 'components/name-to-domain/NameToDomainMappings'
import { NAME_TO_DOMAIN_MAPPINGS_FORM } from 'constants/name-to-domain-constants'
import { withForm } from 'decorators/withForm'
import { useCreateNameToDomainMappings } from 'hooks/useCreateNameToDomainMappings'
import { nameToDomainValidator } from 'validators/name-to-domain'

const INITIAL_MAPPINGS = [{ name: {}, domain: '' }]

type NameToDomainFormProps = {
  change: (...args: any[]) => any
  handleSubmit: (...args: any[]) => any
  valid: boolean
}

const NameToDomainForm = ({ change, handleSubmit, valid }: NameToDomainFormProps) => {
  const { mutateAsync: createNewMappings } = useCreateNameToDomainMappings()

  const onSubmit = async (values: any) => {
    const success = await createNewMappings(values.mappings)

    if (success) change('mappings', [])
  }

  const CSVUpload = <NameToDomainCsvUpload />

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Card className="name-to-domain-form">
        <CardHeader action={CSVUpload} title="Add new mappings" />
        <CardContent>
          <NameToDomainFields name="mappings" />
        </CardContent>
        <CardActions>
          <Button color="primary" disabled={!valid} type="submit" variant="outlined">
            Save new mappings
          </Button>
        </CardActions>
      </Card>
    </form>
  )
}

export default withForm({
  form: NAME_TO_DOMAIN_MAPPINGS_FORM,
  validate: nameToDomainValidator,
  initialValues: {
    mappings: INITIAL_MAPPINGS,
  },
})(NameToDomainForm)
